module.exports = __webpack_public_path__ + "assets/icons/waiting-hauler.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/emojies/waiting-hauler.png
// module id = ./src/styles/icons/emojies/waiting-hauler.png
// module chunks = 0